@if (showEnvironmentBar) {
  <div class="p-3 mb-2 bg-warning text-dark text-center d-print-none">Vous êtes actuellement
    dans
    l'environnement:
    <strong>"{{ environmentName }}"</strong>,
    <span class="ms-2">isDebug: <strong>{{ isDebug ? "true" : "false" }}</strong></span>
    <span class="ms-2">
      @if (!isDebug) {
        <a (click)="activateDebug(); $event.preventDefault()" href="#">Activate Debug Mode</a>
      }
      @if (isDebug) {
        <a (click)="deactivateDebug(); $event.preventDefault()" href="#">Deactivate Debug Mode</a>
      }
    </span>
    <span class="ms-2">
      Environment Parameters Override ({{ numberOfEnvironmentParametersOverridden }})
    </span>
    <a (click)="doNotShowEnvironmentBar(); $event.preventDefault()" class="ms-5" href="#">Ne plus afficher</a>
  </div>
}
